import React from "react";

export default function InfoCard({ icon, title, text }) {
  return (
    <div className="rounded-2xl border bg-white p-4 shadow-sm">
      <div className="flex items-center gap-2">
        <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-50">
          {icon}
        </div>
        <div className="font-semibold text-slate-900">{title}</div>
      </div>
      <p className="mt-2 text-[14px] text-slate-600">{text}</p>
    </div>
  );
}
